import axios from '../../axios';

const patientAiDataService = {
    // Save AI data for a patient
    savePatientAiData: async (aiData) => {
        try {
            const response = await axios.post('/api/patient-ai-data/', aiData);
            return response.data;
        } catch (error) {
            console.error('Error saving patient AI data:', error);
            throw error;
        }
    },

    // Get AI data for a patient
    getPatientAiData: async (patientId, facilityId = null) => {
        try {
            const params = facilityId ? { facilityId } : {};
            const response = await axios.get(`/api/patient-ai-data/patient/${patientId}`, { params });
            return response.data;
        } catch (error) {
            console.error('Error getting patient AI data:', error);
            throw error;
        }
    },

    // Get latest AI data for a patient
    getLatestPatientAiData: async (patientId, facilityId = null) => {
        try {
            const params = facilityId ? { facilityId } : {};
            const response = await axios.get(`/api/patient-ai-data/patient/${patientId}/latest`, { params });
            return response.data;
        } catch (error) {
            console.error('Error getting latest patient AI data:', error);
            throw error;
        }
    },

    // Update AI data
    updatePatientAiData: async (aiDataId, updateData) => {
        try {
            const response = await axios.put(`/api/patient-ai-data/${aiDataId}`, updateData);
            return response.data;
        } catch (error) {
            console.error('Error updating patient AI data:', error);
            throw error;
        }
    },

    // Delete AI data (soft delete)
    deletePatientAiData: async (aiDataId, updatedBy) => {
        try {
            const response = await axios.delete(`/api/patient-ai-data/${aiDataId}`, {
                data: { updatedBy }
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting patient AI data:', error);
            throw error;
        }
    }
};

export default patientAiDataService;
